// Dependecies

import { useState, useEffect } from 'react';
import { reject } from 'lodash';

// Store
import user from '../../store/user';
import maintenaceCompany from '../../store/maintenaceCompany';

// Hooks
import useLanguage from '../useLanguage';

function useNotificationRead() {
  const [newMaintenancesCompany, setNewMaintenancesCompany] = useState(0);
  const [, maintenancesActions] = maintenaceCompany();
  const [userStore] = user();
  const { locale } = useLanguage();

  useEffect(() => {
    if (userStore.token) {
      const data2 = {
        licensePlate: '',
      };

      maintenancesActions.setReadMaintenancesCompany(userStore.token, data2, locale).then(
        (maintenancesResponse) => {
          setNewMaintenancesCompany(maintenancesResponse.read);
        },
        (e) => {
          if (e.status === 401) {
            reject(e);
          }
          reject('Error');
        }
      );
    }
  }, [userStore.token]);

  return {
    newMaintenancesCompany,
  };
}

export default useNotificationRead;
